(function ($) {
  $(function () {
    
    var sectionClass = document.querySelectorAll(".featured-for-tab");

    if ($(sectionClass).length > 0) {
      sectionClass.forEach((sectionItem) => {
        var tabNav = sectionItem.querySelectorAll("ul.tabs-nav li")
        tabNav.forEach((element) => {
          element.addEventListener("click", function () {
            var tab_id = element.getAttribute("data-tab");
            for (let i = 0; i < tabNav.length; i++) {
              tabNav[i].classList.remove("current")
            }
            element.classList.add("current")
            var content = sectionItem.querySelectorAll(".tab-content")
            for (let i = 0; i < content.length; i++) {
              var id = content[i].getAttribute("id")
              if (id == tab_id) {
                content[i].classList.add("current")
              } else {
                content[i].classList.remove("current")
              }
            }
          })
        });
      })
    }

    $(document).on("click", ".featured-for-tab #forgot-password", function () {
      $(".featured-for-tab #login-wrapper").hide();
      $(".featured-for-tab #forgot-wrapper").show();
    });

    $(document).on("click", ".featured-for-tab #back-login", function () {
      $(".featured-for-tab #login-wrapper").show();
      $(".featured-for-tab #forgot-wrapper").hide();
    });

    $(document).on("click", ".mega-menu #popup-forgot-password", function () {
      $(".mega-menu #popup-login-wrapper").hide();
      $(".mega-menu #popup-forgot-wrapper").show();
    });

    $(document).on("click", ".mega-menu #popup-back-login", function () {
      $(".mega-menu #popup-login-wrapper").show();
      $(".mega-menu #popup-forgot-wrapper").hide();
    });

    $(".foryou-form .col-two-wrap .label-wrap .input-wrap")
    .on('focus', function () {
      $(this).parent(".input-wrap").addClass("selected-state");
    }).on('blur', function () {
      $(this).parent(".input-wrap").removeClass("selected-state");
    });

    $(document).on('blur', ".foryou-form .col-two-wrap .label-wrap .input-wrap input", function () {
      if ($(this).val()) {
        $(this).parent().addClass("used");
      } else {
        $(this).parent().removeClass("used");
      }
    });

    //password-show
    $(document).on("click",'.foryou-form .form-wrap .input-wrap .eye-wrap', function () {
      var x = $(this).closest('.row-wrap').find('input').attr('type');
      if (x.toString() === "password") {
        x = "text";
        $(this).closest('.row-wrap').find('input').attr('type', x );
        $(this).addClass("eye-active");
      } else {
        x = "password";
        $(this).closest('.row-wrap').find('input').attr('type', x );
        $(this).removeClass("eye-active");
      }
    });
  });
})(jQuery);
